// Version : 0.0.1
// Author : AGALYA
/* eslint-disable import/no-anonymous-default-export */
import RecurringDepositProposalActionTypes from './recurring-deposit-proposal.types';
import { docodeHexResponse } from '../../../_common/common.utils';

const INITIAL_STATE = {
	// Add Required Deposit Proposal Response
	addRecurringDepositProposalResponse: null,

	// Update Required Deposit Proposal Response
	updateRecurringDepositProposalResponse: null,

	// Get Required Deposit Proposal Resposne
	getRecurringDepositProposalResponse: null,
	getRecurringDepositProposalListArr: [],

	// Fetch Required Deposit Proposal Response
	fetchRecurringDepositProposalResponse: null,
	fetchRecurringDepositProposalArr: [],

	// Delete Required Deposit Proposal Response
	deleteRecurringDepositProposalResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** *********************  START ADD RECURRING DEPOSIT PROPOSAL  ******************** */
		case RecurringDepositProposalActionTypes.ADD_RD_PROPOSAL_SUCCESS:
			return { ...state, addRecurringDepositProposalResponse: action.payload };

		case RecurringDepositProposalActionTypes.ADD_RD_PROPOSAL_FAILURE:
			return { ...state, addRecurringDepositProposalResponse: action.payload };

		case RecurringDepositProposalActionTypes.ADD_RD_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, addRecurringDepositProposalResponse: null };
		/** *********************  END ADD RECURRING DEPOSIT PROPOSAL  ******************** */

		/** *********************  START UPDATE RECURRING DEPOSIT PROPOSAL  ******************** */
		case RecurringDepositProposalActionTypes.UPDATE_RD_PROPOSAL_SUCCESS:
			return { ...state, updateRecurringDepositProposalResponse: action.payload };

		case RecurringDepositProposalActionTypes.UPDATE_RD_PROPOSAL_FAILURE:
			return { ...state, updateRecurringDepositProposalResponse: action.payload };

		case RecurringDepositProposalActionTypes.UPDATE_RD_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, updateRecurringDepositProposalResponse: null };
		/** *********************  END UPDATE RECURRING DEPOSIT PROPOSAL  ******************** */

		/*************** START FETCH RECURRING DEPOSIT PROPOSAL ***************/
		case RecurringDepositProposalActionTypes.FETCH_RD_PROPOSAL_SUCCESS:
			return {
				...state,
				fetchRecurringDepositProposalResponse: action.payload,
				fetchRecurringDepositProposalArr: docodeHexResponse(
					action.payload,
					'FetchRecurringDepositInfoKey',
				),
			};

		case RecurringDepositProposalActionTypes.FETCH_RD_PROPOSAL_FAILURE:
			return { ...state, fetchRecurringDepositProposalResponse: action.payload };

		case RecurringDepositProposalActionTypes.FETCH_RD_PROPOSAL_RESPONSE_CHANGED:
			return {
				...state,
				fetchRecurringDepositProposalResponse: null,
			};
		/*************** END FETCH RECURRING DEPOSIT PROPOSAL ***************/

		/*************** START GET RECURRING DEPOSIT PROPOSAL ***************/
		case RecurringDepositProposalActionTypes.GET_RD_PROPOSAL_SUCCESS:
			return {
				...state,
				getRecurringDepositProposalResponse: action.payload,
				getRecurringDepositProposalArr: docodeHexResponse(
					action.payload,
					'GetRecurringDepositProposalKey',
				),
			};

		case RecurringDepositProposalActionTypes.GET_RD_PROPOSAL_FAILURE:
			return { ...state, getRecurringDepositProposalResponse: action.payload };

		case RecurringDepositProposalActionTypes.GET_RD_PROPOSAL_RESPONSE_CHANGED:
			return {
				...state,
				getRecurringDepositProposalResponse: null,
				getRecurringDepositProposalArr: [],
			};
		/*************** END GET RECURRING DEPOSIT PROPOSAL ***************/

		/*************** START DELETE RECURRING DEPOSIT PROPOSAL ***************/
		case RecurringDepositProposalActionTypes.DELETE_RD_PROPOSAL_SUCCESS:
			return { ...state, deleteRecurringDepositProposalResponse: action.payload };

		case RecurringDepositProposalActionTypes.DELETE_RD_PROPOSAL_FAILURE:
			return { ...state, deleteRecurringDepositProposalResponse: action.payload };

		case RecurringDepositProposalActionTypes.DELETE_RD_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, deleteRecurringDepositProposalResponse: null };
		/*************** END DELETE RECURRING DEPOSIT PROPOSAL ***************/

		default:
			return state;
	}
};
